
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useModal from "hooks/useModal";
import { getBilling, getBillingApproval } from "redux/actions/UserBilling";
import CommonTable from "components/commonTable/CommonTable";
import CommonConfirmModel from "components/commonConfirmModel/CommonConfirmModel";
import Header from "components/header/Header";
import CommonDialog from "components/commonDialog/CommonDialog";
import Loader from "components/loader/Loader";
import { rejectFormData } from "./BillingData";
import BillAmount from "./BillingAmount";
import "./Billing.scss";
function Billing() {

const dispatch = useDispatch();
const [totalAmount, setTotalAmount] = useState(0);
const [selectedCheckRows, setSelectedCheckRows] = useState([]);
const [modelStatus, setModelStatus] = useState("");
const [selectedId, setSelectedId] = useState("");
const [openReject, setOpenReject] = useState(false);
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);

const [searchParams] = useSearchParams();
const params = Object.fromEntries([...searchParams]);

let filter = {
page: page,
pageSize: rowsPerPage,
magicToken: params?.magicToken || "",
};

const { open, toggle } = useModal();
const billingData = useSelector(
(state) => state?.userBilling?.userBilling?.data
);
const billingLoader = useSelector((state) => state?.userBilling?.loading);

useEffect(() => {
  dispatch(getBilling(filter));
}, []);

useEffect(() => {
  setTotalAmount(selectedCheckRows.reduce((n, { price }) => parseFloat(n) + parseFloat(price), 0));
}, [selectedCheckRows]);

const handleApprovModel = () => {
  setModelStatus("approval");
  toggle();
};

const handleCancel = () => {
  toggle();
};

const confirmApproval = () => {
  const approvalIds = selectedCheckRows?.map((item) => item.id);
  dispatch(
    getBillingApproval({
    approvalIds: approvalIds?.toString(),
    magicToken: params?.magicToken,
    }, setSelectedCheckRows)
    );
  toggle();
};

const onClickMoreIcon = (data, type) => {
const status = ["duty slip", "proforma invoice"];
const statusTypeLowercase = type?.toLowerCase();

setSelectedId(data?.id);
if (status?.includes(statusTypeLowercase)) {
  const pdf = statusTypeLowercase === "duty slip" ? data?.dutySlip?.url : data?.name?.url;
  if(pdf) {
    window.open(pdf, "_blank");
  }
  } else if (statusTypeLowercase === "reject") {
    setOpenReject(true);
  }
};

const onDialog = (data) => {
  const value = {
    rejectionId: selectedId,
    rejectionReason: data["Reject Reason"],
  };
  dispatch(getBillingApproval({ rejection: value, magicToken: params?.magicToken }, setSelectedCheckRows));
  setOpenReject(false);
};

const handleChangePage = (event, newPage) => {
  setPage(newPage);
  dispatch(getBilling({ ...filter, page: newPage }));
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value));
  setPage(0);
  dispatch(
    getBilling({ ...filter, page: 0, pageSize: parseInt(event.target.value) })
  );
};

return (
  <div>
    <Header />
    <div className={"p20"}>
      <BillAmount
        totalAmount={totalAmount}
        handleApprovModel={handleApprovModel}
        selectedCheckRows={selectedCheckRows}
      />
    {billingLoader ? (
      <Loader />
    ) : (
      <CommonTable
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        data={billingData}
        setSelectedCheckRows={setSelectedCheckRows}
        tabName={"Billing"}
        onClickMoreIcon={onClickMoreIcon}
      />
    )}
    </div>
    <CommonConfirmModel
      open={open}
      handleClose={toggle}
      selectType="billLink"
      type={"Share with Company"}
      modelStatus={modelStatus}
      handleCancel={handleCancel}
      confirmApproval={confirmApproval}
      totalInvoice={selectedCheckRows?.length}
    />
    {openReject ? (
      <CommonDialog
        className="marginbottom20"
        open={openReject}
        handleClose={() => setOpenReject(false)}
        selectedCheckRows={selectedCheckRows}
        formData={rejectFormData}
        button={"dialogButton"}
        onSubmittBtn={onDialog}
        selectType={"Send"}
      />
  ) : null}
  </div>
);
}

export default Billing;
